import { render } from "./FedresursInfo.vue?vue&type=template&id=3401e592"
import script from "./FedresursInfo.vue?vue&type=script&lang=js"
export * from "./FedresursInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__